<template>
  <DashboardPage>
    <BottlerForm :id="route.params.id" />
  </DashboardPage>
</template>
  
<script setup>
import { useRoute } from 'vue-router';

import DashboardPage from '@/components/DashboardPage.vue'

import BottlerForm from './components/BottlerForm.vue';

const route = useRoute()

</script>